import {Dropdown as AntDropdown} from "antd";

export const Dropdown = AntDropdown;
export default Dropdown;
